import React, { useCallback, useMemo, useRef, useState } from 'react';
import { Select } from 'tea-component';
import { RangePicker } from './RangePicker';
import './index.scss';
// import 方式
import moment, { Moment } from 'moment';
import { DateShortcutType, ShortcutOptionType, shortcutOption } from './_config';

// const RangePicker = DatePicker.RangePicker;

interface OptionsMapType {
  [type: string]: {
    value: string;
    text: string;
    text_cn?: string;
  };
}

const optionsMap: OptionsMapType = {
  hour: { value: 'hour', text: 'Hour', text_cn: '时' },
  date: { value: 'date', text: 'Day', text_cn: '日' },
  week: { value: 'week', text: 'Week', text_cn: '周' },
  month: { value: 'month', text: 'Month', text_cn: '月' },
  year: { value: 'year', text: 'Year', text_cn: '年' },
};

export default (props: any) => {
  const {
    value = [moment(), moment()],
    defaultValue = {},
    type = 'date',
    typeList = ['date'],
    timeTabDisabled = false,
    showSelectType = true,
    showLabelPrefix = true,
    showShortcut = true,
    setShortcutOption,
    startOfWeek = 0,
    onChange,
    customOption = {},
    language,
    startOfTime = '1971-01-01', // 所有时间的起始时间
    allowRange,
    shortCutType,
    latestDate = {
      // date:moment().subtract(1, 'day'),
      // week: moment().weekday(-7),
      // month: moment().subtract(1,'month').startOf('month')
    }, // 最新有数据的时间
    isReseted,
    overlayClassName = '',
    disabledQuarter,
    ...restProps
  } = props;

  const isCN = ['cn', 'zh_CN'].includes(language);

  const calendarInfoRef = useRef<any>({
    [type]: value,
  });

  const childRef = useRef();
  // const [calendarType, setCalendarType] = useState(type);
  // 左侧快捷选择状态设置
  const [selectedLeftType, setSelectLeftType] = useState('');
  // 选择日期类型
  const handelChangeType = useCallback(
    (type: string) => {
      // 防止单个日期时选中下拉的选项出现无效时间的问题
      if (typeList?.length <= 1) return;
      const value = calendarInfoRef.current?.[type];
      setSelectLeftType('');
      if (value && !isReseted) {
        onChange(value, type);
      } else {
        onChange(defaultValue?.[type] || [null, null], type);
      }
    },
    [onChange, isReseted],
  );

  // 接管rangepicker 中的onchange
  const handleChangeValue = useCallback(
    (value: Array<Moment | '' | null>, context) => {
      setSelectLeftType('');
      calendarInfoRef.current[type] = value;
      onChange(value, type);
    },
    [onChange],
  );
  const options = typeList.map((val: string) => {
    const { value, text, text_cn } = optionsMap[val] || {};
    if (isCN) {
      return { value, text: text_cn };
    }
    return { value, text };
  });
  const calendarType: string = type === 'hour' ? 'date' : type;
  const showTime: boolean = type === 'hour';
  const curDefaultValue = defaultValue[type];
  const curProps: any = customOption[type];
  const shortcut = useMemo(() => {
    // 配置左侧栏快捷操作
    let shortcutList: DateShortcutType[] = [];
    if (showShortcut) {
      const typeCur = shortCutType ? shortCutType : type;
      shortcutList = shortcutOption(startOfTime, latestDate, allowRange)?.[typeCur] || [];
    }
    // 是否有自定义左侧栏快捷操作
    if (showShortcut && typeof setShortcutOption === 'function') {
      // 此处是浅拷贝，注意setShortcutOption不要修改参数
      const newShortcutOption: ShortcutOptionType = setShortcutOption({
        ...shortcutOption(startOfTime, latestDate, allowRange),
      });
      shortcutList = newShortcutOption?.[type] || [];
    }
    if (shortcutList.length < 1) {
      return null;
    }
    return shortcutList.map((item: DateShortcutType) => {
      return (
        <p
          key={item?.name}
          className={`dtb-rangepicker-shortcut ${
            selectedLeftType === item?.name && 'dtb-rangepicker-shortcut-hover'
          }`}
          onClick={() => {
            handleChangeValue(item.onClick(), type);
            setSelectLeftType(item?.name);
            //  关闭时间组件弹出窗
            childRef?.current?.setPopActive();
          }}
        >
          {isCN ? item.nameCN : item.name}
        </p>
      );
    });
  }, [type, setShortcutOption, selectedLeftType, handleChangeValue]);

  const rangePrefix = useMemo(() => {
    if (showSelectType || !showLabelPrefix) {
      return null;
    }
    const { text, text_cn } = optionsMap[type] || {};
    return <div className="dtb-rangepicker-label-prefix">{isCN ? text_cn : text}</div>;
  }, [showSelectType, type, language]);

  return (
    <>
      {showSelectType && (
        <Select
          appearance="button"
          options={options}
          disabled={timeTabDisabled || typeList?.length <= 1}
          value={type}
          onChange={(value) => handelChangeType(value)}
          className="dtb-datepicker-prefix"
          matchButtonWidth={true}
        />
      )}
      <>
        <RangePicker
          rangePrefix={rangePrefix}
          key={type}
          {...restProps}
          {...curProps}
          ref={childRef}
          showSelectType={showSelectType}
          header={shortcut}
          startOfWeek={startOfWeek}
          calendarType={calendarType}
          disabledQuarter={disabledQuarter}
          value={value}
          defaultValue={curDefaultValue}
          showTime={showTime}
          onChange={handleChangeValue}
          overlayClassName={`${
            calendarType === 'year' ? 'dtb-rangepicker-year-overlay' : ''
          } ${overlayClassName}`}
        />
      </>
    </>
  );
};
